export default __webpack_public_path__ + "static/media/gasell.9f6482a7.png";